
export default function CasesCTA() {
  return (
    <section className="py-24 bg-[#0A0A0A] relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#10B981]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#10B981]/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <div className="inline-flex items-center gap-2 bg-[#10B981]/10 border border-[#10B981]/30 rounded-full px-4 py-2 mb-8">
          <i className="ri-rocket-2-line text-[#10B981]"></i>
          <span className="text-[#10B981] text-sm font-medium whitespace-nowrap">Seja o Próximo Caso de Sucesso</span>
        </div>
        
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
          Pronto para <span className="text-[#10B981]">Transformar</span> seu Negócio?
        </h2>
        
        <p className="text-white/70 text-lg md:text-xl mb-10 max-w-2xl mx-auto">
          Agende uma demonstração gratuita e descubra como a IA da NeuroAgents pode multiplicar seus resultados em até 30 dias.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://wa.me/5541992584018"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-3 bg-[#10B981] hover:bg-[#0EA472] text-black px-8 py-4 rounded-full font-bold transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            <span>Agendar Demonstração Grátis</span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </a>
          
          <a
            href="/"
            className="flex items-center gap-2 text-white/70 hover:text-white px-6 py-4 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line text-xl"></i>
            <span>Ver como funciona</span>
          </a>
        </div>
        
        {/* Trust badges */}
        <div className="mt-12 pt-12 border-t border-white/10">
          <div className="flex flex-wrap items-center justify-center gap-8">
            <div className="flex items-center gap-2 text-white/60">
              <i className="ri-shield-check-line text-[#10B981]"></i>
              <span className="text-sm whitespace-nowrap">Garantia de 7 dias</span>
            </div>
            <div className="flex items-center gap-2 text-white/60">
              <i className="ri-time-line text-[#10B981]"></i>
              <span className="text-sm whitespace-nowrap">Setup em 24 horas</span>
            </div>
            <div className="flex items-center gap-2 text-white/60">
              <i className="ri-customer-service-2-line text-[#10B981]"></i>
              <span className="text-sm whitespace-nowrap">Suporte dedicado</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
